"use client";

import { useActionState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2 } from "lucide-react";
import { forgotPasswordAction, type ForgotState } from "./actions";

export default function ForgotForm({ locale }: { locale: string }) {
  const de = locale === "de";
  const [state, action, isPending] = useActionState<ForgotState, FormData>(
    forgotPasswordAction,
    {}
  );

  if (state.sent) {
    return (
      <div className="rounded-md bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
        <p className="flex items-start gap-2">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
          {de
            ? "Wenn ein Konto mit dieser E-Mail existiert, haben wir dir gerade einen Link zum Zurücksetzen geschickt. Schau auch im Spam-Ordner nach."
            : "If an account with this email exists, we just sent you a reset link. Check your spam folder too."}
        </p>
      </div>
    );
  }

  return (
    <form action={action} className="space-y-4">
      {state.error && (
        <div className="rounded-md bg-destructive/10 px-4 py-3 text-sm text-destructive">
          {de ? "Bitte gib deine E-Mail-Adresse ein." : "Please enter your email address."}
        </div>
      )}
      <div className="space-y-1.5">
        <Label htmlFor="email">{de ? "E-Mail" : "Email"}</Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          placeholder="name@firma.de"
        />
      </div>
      <Button type="submit" className="w-full" disabled={isPending}>
        {isPending
          ? de
            ? "Wird gesendet …"
            : "Sending …"
          : de
            ? "Link zum Zurücksetzen senden"
            : "Send reset link"}
      </Button>
    </form>
  );
}
